import React from "react";
import Page from "../../Page/Page";
import { connect } from "react-redux";
import { browserHistory } from "react-router";

import Loading from "../../Loading/Loading";
import Well from "@sketchpixy/rubix/lib/Well";
import OrderPaymentInfo from "./OrderPaymentInfo";
import * as actionTypes from "../../../../actions/actions";
import withLoading from "../../withLoadingHOC/withLoadingHOC";
import ButtonToolbar from "@sketchpixy/rubix/lib/ButtonToolbar";
import withPropsMapper from "../../withPropsMapper/withPropsMapper";
import { NotificationManager } from "react-notifications";

import {
  pipe,
  promised,
  appendToFormData,
  withLog,
  showAllServerErrorsAsNotifications,
  createFormData
} from "../../../../helpers/utility";

class OrderPaymentOptions extends React.Component {
  state = {
    orderData: {},
    finalPrice: undefined,
    useCredit: true,
    promoCode: undefined
  };

  componentDidMount() {
    this.props.fetchUserCreditStatus();

    promised(this.props.fetchOrderData, this.props.orderId)
      .then(this.onOrderFetchSuccess)
      .catch(this.onOrderFetchFailure);
  }

  onOrderFetchSuccess = orderData => {
    this.setState({ orderData }, this.props.loading.onLoadingEnd);
  };

  onOrderFetchFailure = withLog((errors = {}) => {
    NotificationManager.error("اشکالی در دریافت اطلاعات رخ داد");
  });

  handleUserCreditStateChange = newValue => {
    this.setState({ useCredit: newValue });
  };

  handleDiscountRequest = promo_code => {
    const formData = appendToFormData({
      promo_code,
      order_code: this.state.orderData.order_code
    });

    promised(this.props.applyPromoCodeToOrder, this.props.orderId, formData)
      .then(this.onApplyPromoSuccess)
      .catch(showAllServerErrorsAsNotifications);
  };

  onApplyPromoSuccess = data => {
    this.setState({
      priceAfterDiscount: data.amount,
      applyDiscountAsyncCall: false,
      promo_code: data.promo_code,
      orderData: data
    });

    NotificationManager.success("کد تخفیف اعمال شد", null, 6000);
  };

  handlePaymentRequest = (use_coins = false) => {
    if (this.state.orderData.order_status === "completed") {
      this.notifyPurchaseSuccess();
      this.redirectAfterPurchase();
      return;
    }

    this.finalizeOrder(use_coins)
      .then(this.payOrder)
      .catch(showAllServerErrorsAsNotifications);
  };

  finalizeOrder = (use_coins = false) => {
    const { orderId } = this.props;
    const promoCode =
      this.state.orderData &&
      this.state.orderData.promotion_code &&
      this.state.orderData.promotion_code.code;

    let formValues = {};
    if (use_coins) {
      formValues = { use_coins };
    } else {
      formValues = {
        use_balance: this.state.useCredit,
        promo_code: promoCode
      };
    }

    const formData = createFormData(formValues);

    return promised(this.props.updateOrder, orderId, formData);
  };

  payOrder = order => {
    if (order.order_status === "completed") {
      this.notifyPurchaseSuccess();
      this.redirectAfterPurchase();
      return;
    }

    const formData = createFormData({
      order_code: this.state.orderData.order_code
    });

    promised(this.props.payOrder, formData)
      .then(this.onPayResponse)
      .catch(showAllServerErrorsAsNotifications);
  };

  onPayResponse = ({ url: bankPaymentURL }) => {
    window.location.href = bankPaymentURL;
  };

  notifyPurchaseSuccess = () => {
    NotificationManager.success("خرید با موفقیت انجام شد");
  };

  redirectAfterPurchase = () => {
    const redirectPath = this.getRedirectPath(this.state.orderData);
    // browserHistory.push(`/dashboard/events/my-events`)
    browserHistory.push(redirectPath);
  };

  needsBankPayment = (
    {
      finalPrice: priceAfterDiscount,
      orderData: { amount: fullPrice },
      useCredit
    },
    { userCredit: { balance } }
  ) =>
    useCredit
      ? priceAfterDiscount
        ? priceAfterDiscount >= balance
        : fullPrice >= balance
      : true;

  isStudent = () => this.props.userType === "STUDENT";

  getRedirectPath = ({ service: { code, type } }) => {
    const newType = type === "exam" ? "event" : type;
    return `/ext-redirect/v/${newType}/${code}`;
  };

  render() {
    if (this.props.loading.isLoading || this.props.userCredit.aSyncCall) {
      return <Loading />;
    }

    return (
      <Page>
        <Well>
          <ButtonToolbar>
            <span>
              <span>اطلاعات پرداخت</span>
            </span>
          </ButtonToolbar>
        </Well>

        <OrderPaymentInfo
          order={this.state.orderData}
          onPaymentRequest={this.handlePaymentRequest}
          finalPrice={this.state.finalPrice}
          needsBankPayment={this.needsBankPayment(this.state, this.props)}
          onDiscountRequest={this.handleDiscountRequest}
          onUseCreditChange={this.handleUserCreditStateChange}
          userCreditAmount={this.props.userCredit.balance}
          userCoins={this.isStudent() ? this.props.userCredit.coins : 0}
          shouldUseCredit={this.state.useCredit}
          priceAfterDiscount={this.state.priceAfterDiscount}
        />
      </Page>
    );
  }
}

const propsMapper = {
  orderId: (_, props) => parseInt(props.params.orderId, 10)
};

const actions = {
  fetchOrderData: (orderId, { resolve, reject }) => ({
    type: actionTypes.FETCH_SINGLE_ORDER_REQUEST,
    orderId,
    resolve,
    reject
  }),
  updateOrder: (orderId, formData, { resolve, reject }) => ({
    type: actionTypes.UPDATE_ORDER_REQUEST,
    orderId,
    formData,
    resolve,
    reject
  }),
  fetchUserCreditStatus: () => ({
    type: actionTypes.FETCH_USER_BALANCE_REQUEST
  }),
  applyPromoCodeToOrder: (orderId, formData, { resolve, reject }) => ({
    type: actionTypes.APPLY_PROMO_CODE_REQUEST,
    orderId,
    formData,
    resolve,
    reject
  }),
  payOrder: (formData, { resolve, reject }) => ({
    type: actionTypes.PAY_ORDER_REQUEST,
    formData,
    resolve,
    reject
  })
};

const mapStateToProps = state => ({
  userCredit: state.userBalance,
  userType: state.auth.userType
});

const HOC = pipe(
  withPropsMapper(propsMapper),
  withLoading({ initialLoading: true }),
  connect(
    mapStateToProps,
    actions
  )
);

export default HOC(OrderPaymentOptions);



// WEBPACK FOOTER //
// ./src/components/common/orders/OrderPaymentOptions/OrderPaymentOptions.js